<template>
	<div>
		<el-dialog :visible.sync="showcargo" title="选择商品" :width="width" :append-to-body="true" :close-on-click-modal="false">
			<cargolist ref="cargolist" style="margin-top:-20px" @tips="tips" @checkchange="checkchange"></cargolist>
			<el-row style="margin-top:10px" v-if="!checktrigger">
				<el-col :span="11" style="color:transparent">1</el-col>
				<el-col :span="8">
					<el-button type="success" size="mini" @click="addcargo">确 定</el-button>
					<el-button size="mini" @click="showcargo=false" style="margin-left:10px">取 消</el-button>
				</el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="showerror" title="同商品同国家不同税率" width="300" :close-on-click-modal="false" :append-to-body="true" @close="GetCnoByTaxscheme">
			<el-table
			      :data="errorlist"
			      style="width: 100%" :height="300">
			      <el-table-column
			        prop="cno"
			        label="商品编号"
			        width="120">
			      </el-table-column>
			      <el-table-column
			        prop="c_name"
			        label="方案名称"
			        width="180">
			      </el-table-column>
			      <el-table-column
			        prop="showname"
			        label="国家">
			      </el-table-column>
				  <el-table-column
				    prop="addedtax"
				    label="税率"
					width="80">
				  </el-table-column>
			    </el-table>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import cargolist from '@/components/baseinfo/cargocnolist';
export default {
	components: {
		cargolist
	},
	props: {},
	data() {
		return {
			width:(window.innerWidth*70/100)+'px',
			showcargo:false,
			searchparam:{},
			selectsingle:false,//是否只能选择一条,
			checktrigger:false,
			c_id:'',
			errorlist:[],
			showerror:false,
			gridheight:'',
			tips:'',
			divclass:''
		};
	},
	mounted() {
		
	},
	methods: {
		init(param) {
			var that=this;
			this.showcargo=true;
			if(param.c_id!=undefined)
				this.c_id=param.c_id;
			if(param.checktrigger!=undefined)
				this.checktrigger=param.checktrigger;
			if(param.gridheight!=undefined)
				this.gridheight=param.gridheight;
			if(param.tips!=undefined)
				this.tips=param.tips;
			if(that.$refs.cargolist!=undefined){
				that.$refs.cargolist._data.p_sort='';
				that.$refs.cargolist._data.searchbox='';
				that.$refs.cargolist.ClearSearch();
			}
			this.GetCnoByTaxscheme();
		},
		GetCnoByTaxscheme(){
			var that=this;
			var p_sort='',searchbox='',searchlist='';
			if(that.$refs.cargolist!=undefined){
				p_sort=that.$refs.cargolist._data.p_sort;
				searchbox=that.$refs.cargolist._data.searchbox;
				searchlist=that.$refs.cargolist._data.searchlist;
			}
			this.$tool.loading2('正在加载', 'cargolist');
			this.$apipost.get.GetCnoByTaxscheme({c_id:this.c_id}).then(res => {
				this.$tool.loadingclose();
				if (res.list!=undefined) {
					//debugger
					this.$nextTick(function(){
						that.$refs.cargolist.init({gridheight:that.gridheight,checktrigger:that.checktrigger,tips:that.tips,checkedlist:res.list,p_sort:p_sort,searchbox:searchbox,searchlist:searchlist});
					});
				}
			});
		},
		addcargo(){
			//获取勾选的商品
			//this.$refs.cargolist
			//debugger
			var rows=[];
			if(this.$refs.cargolist.selectedall)
				rows=this.$refs.cargolist.cargolist;
			else
				rows=this.$refs.cargolist.checkedrow;
			if(this.selectsingle)
			{
				if(rows.length==1){
					this.$emit('addcargorow',{
						rows:rows,
						isclose:true
					});
				}
				else
				{
					this.$tool.message('请选择一条记录', 2);
					return false;
				}
			}	
			else{
				this.$emit('addcargorow',{
					rows:rows,
					isclose:true
				});
			}
			this.showcargo=false;
		},
		checkchange(e){
			var that=this;
			//debugger
			var paraminfo=e.paraminfo;
			paraminfo.c_id=this.c_id;
			paraminfo.handleraccount=localStorage.getItem('u_account');
			paraminfo.isadd=e.selected;
			 //console.log('关系',encodeURIComponent(JSON.stringify(paraminfo)));
			// return false;
			debugger
			this.$tool.loading2('正在设置', 'cargolist');
			this.$apipost.post.SaveCargotoTaxscheme({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if(!e.selected)
						that.GetCnoByTaxscheme();
					if(res.list!=undefined){
						this.$tool.message('部分商品设置成功', 1);
						if(res.list.length>0){
							that.showerror=true;
							that.errorlist=res.list;
						}
					}
					else
						this.$tool.message('设置成功', 1);
				} else {
						this.$tool.message(res.message, 0);
						that.GetCnoByTaxscheme();
				}
			});
		}
	}
}
</script>

<style>
</style>
